<template>
  <div>
    <span class="ed-label">{{ title }} <span class="ed-help">· até {{ max }}</span></span>
    <div class="ed-recurrence-grid">
      <div
        v-for="period in periods"
        :key="period.id"
        class="ed-recurrence"
        :class="{ 'ed-recurrence--on': isSelected(period.id) }"
      >
        <v-checkbox
          :input-value="isSelected(period.id)"
          :label="period.name"
          :disabled="!isSelected(period.id) && (value || []).length >= max"
          color="primary"
          hide-details
          @change="toggle(period.id, $event)"
        ></v-checkbox>
        <InputMoney
          v-if="isSelected(period.id)"
          :value="minimumOf(period.id)"
          textLabel="Valor mínimo"
          :precision="0"
          :required="false"
          :autoFocusOnValidationFail="false"
          @input="setMinimum(period.id, $event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
// Recorrências permitidas + valor mínimo (substitui o InputCheckBoxListWithMoneyInput da tela antiga).
import InputMoney from "@/components/input/InputMoney.vue";

export default {
  name: "EditorRecurrenceList",
  components: { InputMoney },
  props: {
    // [{ donationRecurrencePeriodId, minimumDonationValue }]
    value: { type: Array, default: () => [] },
    periods: { type: Array, default: () => [] },
    title: { type: String, default: "Recorrências de doação permitidas" },
    max: { type: Number, default: 3 },
  },
  methods: {
    isSelected(id) {
      return (this.value || []).some((item) => item.donationRecurrencePeriodId === id);
    },
    minimumOf(id) {
      const item = (this.value || []).find((entry) => entry.donationRecurrencePeriodId === id);
      return item ? item.minimumDonationValue : 0;
    },
    toggle(id, checked) {
      const others = (this.value || []).filter((item) => item.donationRecurrencePeriodId !== id);
      this.$emit("input", checked ? others.concat([{ donationRecurrencePeriodId: id, minimumDonationValue: 0 }]) : others);
    },
    setMinimum(id, amount) {
      // O v-money dispara input a cada re-render mesmo sem mudanca; emitir um array novo nesse caso
      // re-renderiza o campo, que dispara de novo -- laco infinito que travava a aba Pagamentos.
      if (this.minimumOf(id) === (Number(amount) || 0)) return;
      this.$emit("input", (this.value || []).map((item) =>
        item.donationRecurrencePeriodId === id ? { donationRecurrencePeriodId: id, minimumDonationValue: Number(amount) || 0 } : item
      ));
    },
  },
};
</script>

<style scoped>
.ed-recurrence-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 8px;
  align-items: start;
}
.ed-recurrence {
  padding: 8px 12px;
  border: 1px solid var(--ced-border, #e3e5ec);
  border-radius: 8px;
}
.ed-recurrence .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
.ed-recurrence--on {
  border-color: var(--ced-primary, #02acb4);
  background: var(--ced-primary-soft, #e6f7f8);
}
</style>
